import {
  LuNetwork, LuHistory, LuGauge, LuTrendingUp, LuArrowRight, LuXCircle, LuCheckCircle2, LuShieldCheck, LuFileCheck, LuSmartphone,
} from 'react-icons/lu';
import './login.css';

/**
 * Layout das telas públicas (login e cadastro).
 * Mensagem comercial organizada como um MÉTODO: passo a passo numerado e um
 * comparativo antes/depois — a própria tela precisa transmitir organização
 * e processo definido. Só afirma o que o sistema faz de verdade (sem
 * números de clientes ou depoimentos inventados).
 *
 * Desktop: conteúdo comercial à esquerda (claro), login à direita (azul da
 * marca). Celular: login primeiro, conteúdo comercial abaixo.
 */

const STEPS = [
  { n: '01', icon: <LuNetwork />, title: 'Estruture', text: 'Departamentos, funções e os indicadores que cada cargo precisa entregar.' },
  { n: '02', icon: <LuHistory />, title: 'Registre', text: 'Ponto eletrônico e lançamentos diários no sistema, sem planilhas paralelas.' },
  { n: '03', icon: <LuGauge />, title: 'Avalie', text: 'Desempenho mensal de cada colaborador no semáforo: verde, amarelo ou vermelho.' },
  { n: '04', icon: <LuTrendingUp />, title: 'Evolua', text: 'Metas, relatórios e treinamentos para corrigir a rota com base em dados.' },
];

const BEFORE_AFTER = [
  ['Controles em planilhas soltas', 'Uma plataforma única e padronizada'],
  ['Ponto em papel ou sem conferência', 'Ponto eletrônico conforme a Portaria 671'],
  ['Avaliação feita "no feeling"', 'Indicadores claros e iguais para todos'],
  ['Metas sem acompanhamento', 'Resultados acompanhados mês a mês'],
];

export function AuthPitch({ onCreateAccount, compact = false }) {
  return (
    <div className="auth-pitch-inner">
      <div className="auth-brandline">
        <span className="auth-brandline-mark" />
        DHR Gestão · Gestão e Desenvolvimento Empresarial
      </div>

      <h1 className="auth-headline">
        Processos definidos.<br />
        Equipe acompanhada.<br />
        <span className="auth-hl">Resultados medidos.</span>
      </h1>
      <p className="auth-lead">
        A plataforma da DHR Consultoria que organiza a gestão da sua empresa: cada colaborador com
        indicadores claros, ponto registrado e metas acompanhadas mês a mês.
      </p>

      <section className="auth-block">
        <h2 className="auth-block-title">Como sua empresa passa a funcionar</h2>
        <ol className="auth-steps">
          {STEPS.map((s) => (
            <li key={s.n} className="auth-step">
              <div className="auth-step-head">
                <span className="auth-step-n">{s.n}</span>
                <span className="auth-step-icon">{s.icon}</span>
              </div>
              <strong>{s.title}</strong>
              <p>{s.text}</p>
            </li>
          ))}
        </ol>
      </section>

      {!compact && (
        <section className="auth-block">
          <div className="auth-compare">
            <div className="auth-compare-col">
              <div className="auth-compare-head is-before">Hoje, sem processo</div>
              {BEFORE_AFTER.map(([before]) => (
                <div key={before} className="auth-compare-row"><LuXCircle className="is-before" /> {before}</div>
              ))}
            </div>
            <div className="auth-compare-col is-after">
              <div className="auth-compare-head is-after">Com a DHR Gestão</div>
              {BEFORE_AFTER.map(([, after]) => (
                <div key={after} className="auth-compare-row"><LuCheckCircle2 className="is-after" /> {after}</div>
              ))}
            </div>
          </div>
        </section>
      )}

      {!compact && onCreateAccount && (
        <div className="auth-cta">
          <div className="auth-cta-text">
            <strong>Planos a partir de R$ 0</strong>
            <span>Sem cartão de crédito · Sem fidelidade · Pronto em 1 minuto</span>
          </div>
          <button type="button" className="auth-cta-btn" onClick={onCreateAccount}>
            Criar conta grátis <LuArrowRight />
          </button>
        </div>
      )}
    </div>
  );
}

export default function AuthLayout({ children, onCreateAccount, compactPitch = false }) {
  return (
    <div className="auth-page">
      <section className="auth-pitch">
        <AuthPitch onCreateAccount={onCreateAccount} compact={compactPitch} />
      </section>
      <section className="auth-panel">
        <div className="auth-panel-inner">
          {children}
          <div className="auth-trust">
            <span><LuFileCheck /> Portaria 671/MTE</span>
            <span><LuShieldCheck /> 2FA e auditoria</span>
            <span><LuSmartphone /> Funciona no celular</span>
          </div>
        </div>
      </section>
    </div>
  );
}
